<!--suppress XmlDuplicatedId -->
<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let label = '';
    export let value = '';
    export let type = 'text';

    export let invalid = undefined;


    const isInput = () => type === 'text' || type === 'password';
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<div class="form-control">

    <div class="labels">
        <label for={label}>{label}</label>
        <!--{#if invalid}<label class="msg">{invalid}</label>{/if}-->
    </div>

    {#if isInput()}
    <input {type} {value} id={label} class:invalid on:input>
    {:else}
    <textarea {value} id={label} on:input></textarea>
    {/if}
</div>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .form-control {
        margin-bottom: .5rem;
    }

    .labels {
        display: flex;
        justify-content: space-between;
    }

    label {
        display: block;
        font-weight: bold;
        padding: 5px 3px;
    }
    /*label.msg {*/
    /*    color: red;*/
    /*    font-weight: unset;*/
    /*}*/

    input, textarea {
        display: block;
        width: 100%;
        border-radius: 5px;
        padding: 2px 3px;
        outline: none;
        border: 1px solid var(--dark-grey);
        font: inherit;
    }


    .invalid {
        border-color: red;
    }

    textarea {
        resize: none;
        height: 5rem;
    }
</style>